enum LicenseDurationType {
  Days = 1,
  Months = 2,
}

export default LicenseDurationType;
